import React, { FC } from 'react';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import EventDetailContainer from '../@shared/eventDetailContainer';
import { TEventDetailProps } from '../@shared/eventDetailContainer/types/eventDetail.types';

const LiveEventDetail: FC<TEventDetailProps> = (props) => {
  // Component is unreleased
  if (props.fields.isComponentUnreleased) {
    return <UnreleasedComponent />;
  }

  return <EventDetailContainer {...props} />;
};

export default LiveEventDetail;
